import { AxiosInstance } from "axios";
import {
  IFilterSchema,
  IListQueryStringSchema,
  ISortSchema,
} from "../../Schemas/ListQueryString";
import { IResponseBody } from "../../Schemas/EndPoint";

interface Filter extends IFilterSchema {
  column: ReportListColumnFilterable;
}

interface Sort extends ISortSchema {
  column: ReportListColumnSortable;
}

export enum ReportListColumnFilterable {
  NUMBER = "number",
  UPDATED_AT = "updated_at",
}

export enum ReportListColumnSortable {
  CREATED_AT = "created_at",
  ID = "id",
}

export interface ReportListQueryString extends IListQueryStringSchema {
  filters?: Filter[];
  sorts?: Sort[];
}

export interface ReportListResponseBody extends IResponseBody {
  data: {
    total: number;
  };
}

export interface ReportDetails extends IResponseBody {
  data: {
    status: {
      busy: number;
      failed: number;
      created: number;
      sending: number;
      blocked: number;
      rejected: number;
      answered: number;
      canceled: number;
      no_answer: number;
      device_off: number;
      unreachable: number;
      invalid_number: number;
      waiting_for_send: number;
      partner_not_responding: number;
    };
    sent: number;
    pickup: number;
    failed: number;
    sending: number;
    last_reset_at: number;
  };
}

export class ReportListRequest {
  private protectedAxiosInstance: AxiosInstance;

  constructor(protectedAxiosInstance: AxiosInstance) {
    this.protectedAxiosInstance = protectedAxiosInstance;
  }

  private getPath() {
    return `/admin/reports/`;
  }

  async getCallQueue(
    queryStrings?: ReportListQueryString
  ): Promise<ReportListResponseBody> {
    try {
      const { data } = await this.protectedAxiosInstance.get(
        this.getPath() + "call-queue-sender",
        {
          params: queryStrings,
        }
      );
      return data;
    } catch (err) {
      // TODO : handle error
      throw err;
    }
  }

  async resetPartnerStatus(partnerId: number): Promise<ReportDetails> {
    try {
      const { data } = await this.protectedAxiosInstance.post(
        this.getPath() + `partners/${partnerId}/reset`
      );
      return data;
    } catch (err) {
      // TODO : handle error
      throw err;
    }
  }
  async resetPbxServersStatus(ServerId: number): Promise<ReportDetails> {
    try {
      const { data } = await this.protectedAxiosInstance.post(
        this.getPath() + `pbx-servers/${ServerId}/reset`
      );
      return data;
    } catch (err) {
      // TODO : handle error
      throw err;
    }
  }

  async resetVoicebrodcastStatus(): Promise<ReportDetails> {
    try {
      const { data } = await this.protectedAxiosInstance.post(
        this.getPath() + `voice-broadcasts/reset`
      );
      return data;
    } catch (err) {
      // TODO : handle error
      throw err;
    }
  }

  async partnerStatus(partnerId: number): Promise<ReportDetails> {
    try {
      const { data } = await this.protectedAxiosInstance.get(
        this.getPath() + `partners/${partnerId}`
      );
      return data;
    } catch (err) {
      // TODO : handle error
      throw err;
    }
  }
  
  async pbxServerStatus(pbxServerId: number): Promise<ReportDetails> {
    try {
      const { data } = await this.protectedAxiosInstance.get(
        this.getPath() + `pbx-servers/${pbxServerId}`
      );      
      return data;
    } catch (err) {
      // TODO : handle error
      throw err;
    }
  }

  async voicebroadcastStatus(): Promise<ReportDetails> {
    try {
      const { data } = await this.protectedAxiosInstance.get(
        this.getPath() + `voice-broadcasts`
      );
      return data;
    } catch (err) {
      // TODO : handle error
      throw err;
    }
  }
}
